/* unplugin-vue-components disabled */import { render } from "./PriceCalculateRender.vue?vue&type=template&id=19072276&scoped=true"
import script from "./PriceCalculateRender.vue?vue&type=script&lang=js"
export * from "./PriceCalculateRender.vue?vue&type=script&lang=js"

import "./PriceCalculateRender.vue?vue&type=style&index=0&id=19072276&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19072276"]])

export default __exports__